import { useInstance } from '@milkdown/react';
import { insertHrCommand } from '@milkdown/preset-commonmark';
import { useCallback, useMemo } from 'react';
import { createClickFunction } from '../../util/notes';
import { useNotesToolbarContext } from '../../context/notes/notes_toolbar_context';
import { useEditorStateContext } from '../../context/notes/notes_editor_state_context';
import { DIVIDER_BUTTON_SUFFIX } from '../../components/notes/consts';
export function useDividerButton() {
    const [isLoading, getEditorInstance] = useInstance();
    const { dividerButtonContext } = useNotesToolbarContext();
    const { captureButtonClick, inCallOrPostCall, readOnlyYn, displayModeYn } = useEditorStateContext();
    const isEnabled = !readOnlyYn && !displayModeYn && dividerButtonContext.isEnabled;
    const handleClick = useCallback(() => {
        typeof captureButtonClick === 'function' &&
            captureButtonClick(`${inCallOrPostCall}-${DIVIDER_BUTTON_SUFFIX}`);
        const clickFunction = createClickFunction(getEditorInstance, isLoading, insertHrCommand.key);
        clickFunction();
    }, [captureButtonClick, getEditorInstance, inCallOrPostCall, isLoading]);
    return useMemo(() => ({
        onClick: handleClick,
        isEnabled,
    }), [handleClick, isEnabled]);
}
//# sourceMappingURL=use_divider_button.js.map